'use client';
import { signOut } from '@/services/apis/modules/auth';
import { useSocket } from '@/stores/context/socketProvider';
import { notify } from '@/utils/funtion';
import { useSession } from 'next-auth/react';
import React, { useEffect } from 'react';
import { signOut as signOutNextAuth } from 'next-auth/react';
import { decodeData } from '@/services/apis/http-server';

interface AntiScreenshotProps {
  children?: React.ReactNode;
}

const AntiScreenshot: React.FC<AntiScreenshotProps> = ({ children }) => {
  useEffect(() => {
    const blockScreenshot = (event: KeyboardEvent) => {
      if (
        event.key === 'PrintScreen' ||
        (event.ctrlKey && event.key === 'p') ||
        (event.metaKey && event.shiftKey && event.key === '3') ||
        (event.metaKey && event.shiftKey && event.key === '4') ||
        (event.metaKey && event.shiftKey && event.key.toLowerCase() === 's') ||
        (event.ctrlKey && event.shiftKey && event.key.toLowerCase() === 's') ||
        (event.altKey && event.key === 'PrintScreen')
      ) {
        event.preventDefault();
      }
    };

    const blockDevTools = (event: KeyboardEvent) => {
      if (
        (event.ctrlKey && event.shiftKey && event.key === 'I') ||
        (event.ctrlKey && event.shiftKey && event.key === 'J') ||
        (event.ctrlKey && event.key === 'U') ||
        (event.metaKey && event.altKey && event.key === 'I') ||
        (event.keyCode == 123 && event.key === 'F12' && event.code === 'F12')
      ) {
        event.preventDefault();
      }
    };

    const disableRightClick = (event: MouseEvent) => event.preventDefault();

    const blockScreenRecording = async () => {
      try {
        const handleScreenShare = async () => {
          const stream = await navigator.mediaDevices.getDisplayMedia();
          stream.getTracks().forEach((track) => {
            track.stop();
          });
        };

        document.addEventListener('keydown', (e) => {
          if (
            (e.ctrlKey && e.shiftKey && e.key === 'R') ||
            (e.metaKey && e.shiftKey && e.key === 'R')
          ) {
            handleScreenShare();
          }
        });

        document.addEventListener('keydown', (e) => {
          if (
            (e.ctrlKey && e.shiftKey && e.key === '5') ||
            (e.metaKey && e.shiftKey && e.key === '5')
          ) {
            e.preventDefault();
            handleScreenShare();
          }
        });
      } catch (error) {
        console.error('Error blocking screen recording:', error);
      }
    };

    const blockSnippingTools = () => {
      if (window.navigator.userAgent.includes('Windows')) {
        const tools = [
          'SnippingTool.exe',
          'ScreenSketch.exe',
          'ms-screenclip.exe',
          'ScreenCapture.exe',
          'Snip & Sketch.exe',
        ];

        const checkAndBlockTools = () => {
          tools.forEach((tool) => {
            if (window.navigator.userAgent.includes(tool)) {
              window.location.href = '/';
            }
          });
        };

        const interval = setInterval(checkAndBlockTools, 500);

        document.addEventListener('keydown', (e) => {
          if (
            (e.shiftKey && e.key.toLowerCase() === 's') || // Windows + Shift + S
            (e.ctrlKey && e.shiftKey && e.key.toLowerCase() === 's') || // Ctrl + Shift + S
            (e.metaKey && e.shiftKey && e.key.toLowerCase() === 's') // Command + Shift + S
          ) {
            e.preventDefault();
            window.blur();
          }
        });

        document.addEventListener('copy', (e) => {
          e.preventDefault();
        });

        document.addEventListener('contextmenu', (e) => {
          e.preventDefault();
        });

        return () => {
          clearInterval(interval);
        };
      }
    };

    const detectScreenshot = () => {
      const canvas = document.createElement('canvas');
      const gl = canvas.getContext('webgl');

      if (gl) {
        const debugInfo = gl.getExtension('WEBGL_debug_renderer_info');
        if (debugInfo) {
          const renderer = gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL);
          if (renderer.includes('Capture') || renderer.includes('Screen')) {
            window.location.href = '/';
          }
        }
      }
    };

    const blockScreenCaptureAPI = () => {
      if (window.HTMLCanvasElement) {
        const originalToBlob = HTMLCanvasElement.prototype.toBlob;
        HTMLCanvasElement.prototype.toBlob = function (
          callback,
          type,
          quality,
        ) {
          return null;
        };
      }
    };

    const blockExtensions = () => {
      const extensions = [
        'Lightshot',
        'Nimbus',
        'Awesome Screenshot',
        'FireShot',
      ];

      setInterval(() => {
        extensions.forEach((ext) => {
          if (document.querySelector(`[data-extension="${ext}"]`)) {
            window.location.href = '/';
          }
        });
      }, 1000);
    };

    detectScreenshot();
    blockScreenCaptureAPI();
    blockExtensions();

    document.addEventListener('keydown', blockScreenshot);
    document.addEventListener('keydown', blockDevTools);
    document.addEventListener('contextmenu', disableRightClick);
    document.addEventListener('selectstart', (e) => e.preventDefault());
    document.addEventListener('dragstart', (e) => e.preventDefault());

    if (
      navigator.mediaDevices &&
      typeof navigator.mediaDevices.getDisplayMedia === 'function'
    ) {
      blockScreenRecording();
    }

    const cleanup = blockSnippingTools();

    return () => {
      document.removeEventListener('keydown', blockScreenshot);
      document.removeEventListener('keydown', blockDevTools);
      document.removeEventListener('contextmenu', disableRightClick);
      document.removeEventListener('selectstart', (e) => e.preventDefault());
      document.removeEventListener('dragstart', (e) => e.preventDefault());
      cleanup?.();
    };
  }, []);

  const { socket, listen } = useSocket();
  const { data: session } = useSession();
  const handleLogOut = async () => {
    await signOut()
      .then(async () => {
        await signOutNextAuth();
        localStorage.clear();
        sessionStorage.clear();
      })
      .then(() => {
        notify('warning', '', 'top-center', 6000);
        window.location.href =
          '/xac-thuc-nguoi-dung?message=Phiên đăng nhập của bạn đã hết hạn, vui lòng đăng nhập lại để tiếp tục sử dụng dịch vụ';
      });
  };

  useEffect(() => {
    const handleSession = async () => {
      if (!session?.info) return;
      try {
        const decode: any = await decodeData(session.info);
        if (decode) {
          const { macToken } = decode;

          if (macToken) {
            listen(macToken, () => {
              handleLogOut();
            });
          }

          if (macToken) {
            listen('signout', (data) => {
              handleLogOut();
            });
          }
        }
      } catch (error) {
        console.error('Error decoding session data:', error);
      }
    };

    handleSession();
  }, [socket]);

  return null;
};

export default AntiScreenshot;
